// Package Imports

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
// import ModuleIdentifierConst from 'core/common/moduleIdentifier';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width="25"
    height="25"
    fill="none"
    stroke="currentColor"
    strokeWidth="4.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M31 12H78Q86 12 86 20V69" />
    <path d="M23 21H72Q80 21 80 29V76" />
    <rect x="14" y="30" width="62" height="58" rx="6" />
    <circle cx="45" cy="49" r="4" />
    <path d="M45 53C45 63 35 64 37 72C39 80 52 78 52 69" />
    <circle cx="68" cy="77" r="12" fill="currentColor" stroke="none" />
    <text
      x="68"
      y="81"
      fontSize="11"
      fontWeight="bold"
      fill="#FFFFFF"
      stroke="none"
      textAnchor="middle"
    >
      1
    </text>
  </svg>
);

const HookInstanceResource: ResourceItem = {
  name: resourceName.hookInstance,
  identifier: ModuleIdentifierConst.HOOK_INSTANCE,
  list: `${resourceName.hookInstance}`,
  create: `${resourceName.hookInstance}/create`,
  edit: `${resourceName.hookInstance}/edit/:id`,
  show: `${resourceName.hookInstance}/show/:id`,
  options: { label: 'Hook Instance', icon },
  meta: {
    label: 'Hook Instance',
    icon,
    parent: resourceName.hook,
  },
};

export default HookInstanceResource;
